module.exports = __webpack_public_path__ + "static/media/MandateTandC.792c4b45.pdf";